import React from 'react';
import { Home, Users, Heart, GraduationCap, Store, Megaphone } from 'lucide-react';
export function GroupBenefits() {
  const groups = [{
    title: 'Para residentes',
    description: 'Encuentra información clara, reporta problemas y mantente conectado con lo que pasa cerca de tu casa.',
    icon: Home
  }, {
    title: 'Para familias',
    description: 'Accede a recursos, eventos, reuniones y canales de participación para temas que afectan tu vida diaria.',
    icon: Users
  }, {
    title: 'Para adultos mayores',
    description: 'Encuentra información accesible, contactos importantes y recursos comunitarios.',
    icon: Heart
  }, {
    title: 'Para jóvenes',
    description: 'Descubre oportunidades para participar, aprender, ayudar y conectar con proyectos locales.',
    icon: GraduationCap
  }, {
    title: 'Para negocios locales',
    description: 'Mantente informado sobre temas comunitarios, eventos, cambios locales y oportunidades de colaboración.',
    icon: Store
  }, {
    title: 'Para líderes comunitarios',
    description: 'Conecta con vecinos, comparte información y ayuda a fortalecer la participación local.',
    icon: Megaphone
  }];
  return <section className="py-24 px-6 lg:px-8 bg-sylmar-light" data-id="element-122">
      <div className="max-w-6xl mx-auto" data-id="element-123">
        <div className="text-center mb-16" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-125">
            Beneficios Para Diferentes Grupos
          </h2>
          <div className="w-24 h-1 bg-sylmar mx-auto rounded-full" data-id="element-126"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-127">
          {groups.map((group, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:border-sky transition-colors" data-id="element-128">
              <div className="w-12 h-12 bg-softblue-dark rounded-xl flex items-center justify-center mb-6" data-id="element-129">
                <group.icon className="w-6 h-6 text-charcoal" data-id="element-130" />
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-131">
                {group.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-132">
                {group.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}